var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"float-right m-1",attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":_vm.agir}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"trash"}}),_vm._v(" Limpar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }